import { messageForConnectionType } from '@tableau/data-catalog-shared';
import React from 'react';

import { Messages } from '~src/codegen/Localize';
import { getCommonTableInfo } from '~src/spacesPlatform/models/CommonTableInfo';
import { Tags } from '~src/tags/components/tooltips/Tags';

import { DetailsTooltipStyles } from '../card/DetailsTooltipStyles';
import { MarkupField } from '../Explorer/widgets/MarkupField';
import { BasicField } from './BasicField';
import { Name } from './Name';
import { Columns } from './TableColumns';
import { Tooltip } from './Tooltip';
import { ContentTooltipProps, TooltipDescriptionTestId } from './TooltipHelper';

export function TableTooltip(props: ContentTooltipProps): JSX.Element {
    const content = props.content;
    const tags = getTags(props.content.tags);
    const commonTable = getCommonTableInfo(content);
    const isDbServer: boolean = commonTable.dbType === 'DatabaseServer';
    return (
        <Tooltip>
          <Name name={content.name} />
          <MarkupField markup={content.description}
                   testId={TooltipDescriptionTestId}
                   extraClasses={[DetailsTooltipStyles.MetadataSectionWithContentDescription]} />
          <Tags tags={tags} />
          <BasicField name={Messages.tableTooltipDatabaseName()} value={commonTable.databaseName} />
          <BasicField name={isDbServer ? Messages.tableTooltipConnectionType() : Messages.tableTooltipFileType() }
                        value={isDbServer ? commonTable.connectionType : messageForConnectionType(commonTable.connectionType)} />
          <BasicField name={isDbServer ? Messages.tableTooltipHostname() : Messages.tableTooltipFilePath() }
                        value={isDbServer ? commonTable.hostName : commonTable.filePath} />
          <Columns columns={commonTable.columns} />
          <BasicField value={commonTable.contactName} name={Messages.tableTooltipContact()} />
        </Tooltip>
    );
}

function getTags(contentTags: any) {
  if(contentTags.length > 0) {
      if(typeof contentTags[0] === 'object') {
          return contentTags.map((tag: {name: any}) => { return tag.name;});
      }
  }
  return contentTags;
}